import { createContext, useContext, ReactNode } from 'react';
import { Location } from 'react-router-dom';
import Teachr from '../Objects/models/Teachr';
import { AppDispatch } from '../Redux/store';

interface SettingsContextType {
    location: Location
    teachr: Teachr;
    dataSponsor: any
    dispatch: AppDispatch
}

const SettingsContext = createContext<SettingsContextType | null>(null);

/**
 * Hook personnalisé pour utiliser le context de procuration
 * @throws Error si utilisé en dehors du ProcurationProvider
 */
export const useSettingsContext = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettingsContext doit être utilisé à l\'intérieur d\'un ProcurationProvider');
    }
    return context;
};

interface SettingsProviderProps {
    children: ReactNode;
    value: SettingsContextType;
}

export const SettingsProvider = ({ children, value }: SettingsProviderProps) => {
    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
};

export type { SettingsContextType };
